/**
 * Updates the query string without Next Router navigation.
 * `router.replace(..., { scroll: false, shallow: true })` still scrolls to top on Next 16
 * (and fires routeChange* listeners). Use history.replaceState instead — same approach as
 * `stripPanelTrueFromBrowserUrl`.
 */
export const replaceBrowserSearchParams = (urlParams: URLSearchParams): void => {
  if (typeof window === 'undefined') return;

  const qs = urlParams.toString();
  const nextUrl = `${window.location.pathname}${qs ? `?${decodeURIComponent(qs)}` : ''}${window.location.hash}`;
  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  if (nextUrl === currentUrl) return;

  const scrollY = window.scrollY;
  const historyState =
    typeof window.history.state === 'object' && window.history.state !== null
      ? { ...window.history.state, as: nextUrl, url: nextUrl }
      : { as: nextUrl, url: nextUrl };

  window.history.replaceState(historyState, '', nextUrl);

  if (window.scrollY !== scrollY) {
    window.scrollTo({ top: scrollY, behavior: 'instant' });
  }
};

export const clearBrowserSearchParams = (): void => {
  if (typeof window === 'undefined') return;
  replaceBrowserSearchParams(new URLSearchParams());
};
